import React, {useEffect, useRef, useState} from "react";
import classNames from "classnames";
import Svg from "@/Components/Svg";
import "@/Scss/Components/video.scss";

const DEFAULT_CONTROLS = ['play', 'volume'];

const Video = (
    {
        source = [],
        poster = "",
        muted = true,
        autoPlay = false,
        loop = false,
        className = '',
        preload = 'none',
        controls = DEFAULT_CONTROLS,
        ...props
    }
) => {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(autoPlay);
    const [isMuted, setIsMuted] = useState(muted);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const handleEnded = () => {
            setIsPlaying(false);
        };

        video.addEventListener("ended", handleEnded);
        return () => {
            video.removeEventListener("ended", handleEnded);
        };
    }, []);

    // useEffect(() => {
    //     const video = videoRef.current;
    //     if (!video) return;
    //
    //     video.load();
    //
    //     if (autoPlay) {
    //         video.play().catch(() => {
    //         });
    //     }
    // }, [source]);


    const togglePlayPause = (e) => {
        e.stopPropagation();
        const video = videoRef.current;
        if (!video) return;

        if (video.paused) {
            video.play();
            setIsPlaying(true);
        } else {
            video.pause();
            setIsPlaying(false);
        }
    };

    const toggleMute = (e) => {
        e.stopPropagation();
        const video = videoRef.current;
        if (!video) return;

        video.muted = !video.muted;
        setIsMuted(video.muted);
    };

    const renderControl = (control) => {
        if (React.isValidElement(control)) return control;

        switch (control) {
            case 'play':
                return (
                    <div key={`play`}
                         className={classNames("video__control__playPauseButton", {
                             play: !isPlaying,
                             pause: isPlaying,
                         })}
                         onClick={togglePlayPause}
                    />
                );
            case 'volume':
                return (
                    <div key={`volume`} className={`video__control__volume`} onClick={toggleMute}>
                        {isMuted
                            ? <Svg id={`volumeOff`} className={`svg__volumeOff`} />
                            : <Svg id={`volumeOn`} className={`svg__volumeOn`} />
                        }
                    </div>
                );
            default:
                return null;
        }
    };

    const shouldRenderControls = controls !== false;
    const parsedControls = Array.isArray(controls)
        ? controls
        : controls === true
            ? DEFAULT_CONTROLS
            : [];

    if (source.length === 0) return null;

    return (
        <div className={classNames("video", className)}>
            <video
                ref={videoRef}
                muted={isMuted}
                autoPlay={autoPlay}
                loop={loop}
                playsInline
                poster={poster}
                preload={preload}
                className={`video__video`}
                {...props}
            >
                {source.map((src) => (
                    <source key={src} src={src} type={`video/${src.split('.').pop()}`} />
                ))}
            </video>
            {shouldRenderControls && (
                <div className={`video__control`}>
                    {parsedControls.map(renderControl)}
                </div>
            )}
        </div>
    );
};

export default Video;
